<div class="main px-5">
  <div class="col-12 d-flex mt-3 justify-content">
    <div class="d-flex col-10">
      <p class="fw-bold text-primary-color mt-3">Movimentação Societária - {{ entidade?.nomeFantasia }}
      </p>
    </div>
  </div>

  <nz-divider class="m-0 p-0 my-2"></nz-divider>

  <div class="d-flex">
    <div class="col-12 px-0 py-3 border-gray box-shadow">
      <form [formGroup]="mudancaSocietariaForm" id="mudancaSocietariaForm" #formElement>
        <div class="row g-4 mb-2">
          <div class="col-sm-12 form-group">
            <div class="row g-4">
              <div class="col-sm-4 form-group">
                <label for="dataMudancaEntidade" class="form-label">Data de mudança</label>
                <nz-date-picker id="dataMudancaEntidade" [nzFormat]="'dd/MM/YYYY'" [nzSize]="'large'"
                  formControlName="dataMudancaEntidade" (input)="onInputDateChange($event, 'dataMudancaEntidade')"
                  [nzAllowClear]="true"></nz-date-picker>
              </div>
            </div>
          </div>

          <div class="col-sm-4 form-group">
            <label for="tipoMudancaEntidade" class="form-label required">Tipo de mudança</label>
            <nz-select formControlName="tipoMudancaEntidade" nzShowSearch nzAllowClear nzPlaceHolder="-" nzSize="large"
              [compareWith]="compareFn">
              <nz-option [nzValue]="item" [nzLabel]="item.nomeTipoMudancaEntidade"
                *ngFor="let item of tipoMudancaLista" />
            </nz-select>
          </div>

          <!-- <div class="col-sm-4 form-group">
            <label for="statusMudancaEntidade" class="form-label">Status mudança entidade</label>
            <nz-select formControlName="statusMudancaEntidade" nzShowSearch nzAllowClear nzPlaceHolder="-"
              nzSize="large" [compareWith]="compareFn">
              <nz-option [nzValue]="item" [nzLabel]="item.nomeStatusMudancaEntidade" *ngFor="let item of statusLista" />
            </nz-select>
          </div> -->

          <div class="col-sm-4 form-group">
            <label for="tipoEntidadesEnvolvidas" class="form-label required">Tipo entidades envolvidas</label>
            <nz-select formControlName="tipoEntidadesEnvolvidas" nzShowSearch nzAllowClear nzPlaceHolder="-"
              nzSize="large" [compareWith]="compareFn">
              <nz-option [nzValue]="item.id" [nzLabel]="item.descricao"
                *ngFor="let item of tipoEntidadesEnvolvidasLista" />
            </nz-select>
          </div>

          <div class="col-12 form-group mt-3">
            <label for="justificativaMudanca" class="form-label">Justificativa de mudança</label>
            <nz-textarea-count [nzMaxCharacterCount]="2000">
              <textarea rows="6" formControlName="justificativaMudanca" placeholder="justificativa de mudança" nz-input
                [maxlength]="2000"></textarea>
            </nz-textarea-count>
          </div>

          <ng-container [ngSwitch]="tipoEntidadesEnvolvidasSelecionada">
            <div *ngSwitchCase="1">
              <div class="col-12 form-group">
                <div class="row g-3">
                  <div class="col-12">
                    <h6>Única Entidade Envolvida</h6>
                  </div>
                  <app-entidade-envolvida-form [entidadeEnvolvidaForm]="mudancaSocietariaForm"
                    [entidadeEnvolvida]="movimentacaoSocietaria?.entidadesEnvolvidas[0]"
                    [tipoEntidadesEnvolvidasSelecionada]="tipoEntidadesEnvolvidasSelecionada"
                    [tipoMudancaSelecionado]="tipoMudancaSelecionado"
                    [dadosIdSelecionado]="dadosIdSelecionado"
                    [idEntidade]="idEntidade"
                    [entidade]="entidade"
                    (tipoEntidadesEnvolvidasSelecionadaChange)="tipoEntidadesEnvolvidasSelecionadaChange($event)"></app-entidade-envolvida-form>
                </div>
              </div>
            </div>

            <div *ngSwitchCase="2">
              <div class="col-12 form-group">
                <div class="row g-3">
                  <div class="col-12">
                    <h6>Várias Entidades Envolvidas</h6>
                  </div>
                  <div class="col-12">
                    <div class="col-12 d-flex justify-content-start">
                      <button nz-button nzType="primary" type="button" (click)="showModal()">Adicionar Entidade
                        Envolvida</button>
                    </div>

                    <nz-divider class="m-0 p-0 mb-4 mt-4"></nz-divider>

                    <div class="d-flex flex-column page-content border border-radius w-100">
                      <nz-table [nzData]="dataSet" [nzSize]="'small'" [nzFrontPagination]="false"
                        [nzShowPagination]="false" (nzQueryParams)="sort($event)" [nzNoResult]="semDadosTemplate">
                        <thead>
                          <tr>
                            <th nzColumnKey="entidade?.nomeRazaoSocial" nzShowSort [nzSortFn]="true">Nome entidade</th>
                            <th nzColumnKey="tipoEnvolvimento?.nomeTipoEnvolvimento" nzShowSort [nzSortFn]="true">Tipo Envolvimento</th>
                            <th class="text-center">Ações</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of dataSet">
                            <td>{{ item?.entidade?.nomeRazaoSocial }}</td>
                            <td>{{ item?.tipoEnvolvimento?.nomeTipoEnvolvimento }}</td>
                            <td class="text-center">
                              <button nz-button type="button" nz-dropdown [nzDropdownMenu]="menu">
                                <span nz-icon nzType="more" nzTheme="outline"></span>
                              </button>
                              <nz-dropdown-menu #menu="nzDropdownMenu">
                                <ul nz-menu>
                                  <li nz-menu-item type="button" (click)="showModal(item)">
                                    <a> Detalhes / Editar</a>
                                  </li>
                                  <li nz-menu-item type="button" (click)="remover(item)">
                                    <a> Remover </a>
                                  </li>
                                </ul>
                              </nz-dropdown-menu>
                            </td>
                          </tr>
                        </tbody>
                      </nz-table>
                      <ng-template #footerTemplate>
                        <section class="d-flex justify-content-end w-100">
                          <app-pagination [itemPorPagina]="10"></app-pagination>
                        </section>
                      </ng-template>
                      <ng-template #semDadosTemplate>
                        <div class="d-flex align-items-center justify-content-center" *ngIf="!dataSet?.length">
                          <nz-empty [nzNotFoundContent]="'Nenhum registro encontrado'"></nz-empty>
                        </div>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <div class="col-12 mt-3">
            <div class="d-flex align-items-center justify-content-between">
              <p class="fw-bold text-primary-color">Documentos</p>
              <i class="fi fi-rs-bank"></i>
            </div>
            <nz-divider class="m-0 p-0 divider-primary-color"></nz-divider>
            <div class="col-12 py-3">
              <app-documento-movimentacao-societaria-list [nomePagina]="nomePagina" [documentoForm]="mudancaSocietariaForm"
                [data]="movimentacaoSocietaria" [paginaMovimentacaoSocietaria]="true"></app-documento-movimentacao-societaria-list>
            </div>
          </div>


          <nz-divider></nz-divider>

          <div id="footer-btns-fixed" [ngClass]="!isModal ? 'col-12 footer-btns-fixed' : 'col-12'">
            <div class="col px-5">
              <div class="row mb-4">
                <div class="d-flex justify-content-between">
                  <div class="col">
                    <button nz-button nzType="default" nzSize="large"
                      class="d-flex justify-content-center fw-semibold rounded-3 fs-6" type="button" (click)="voltar()">
                      Voltar
                      <span class="fs-3 ms-2 mdi--search"></span>
                    </button>
                  </div>

                  <div class="col text-center" *ngIf="testeControl">
                    <p class="fs-5 fw-bold">{{ testeControl }}</p>
                  </div>

                  <!-- <button nz-button type="button" nzType="default" [nzSize]="'large'" class="rounded-pill mx-2"
                  form="mudancaSocietariaForm" (click)="reverter()">
                  Reverter
                </button> -->
                <ng-template [ngxPermissionsOnly]="[roleEnum.MudancaEntidadeGravacao]">

                  <div class="col d-flex justify-content-end">
                    <button nz-button nzType="primary" nzSize="large"
                      class="d-flex justify-content-center fw-semibold rounded-3 fs-6" type="button"
                      form="mudancaSocietariaForm" (click)="salvar()">
                      Salvar cadastro
                      <span class="fs-3 ms-2 mdi--search"></span>
                    </button>
                  </div>
                </ng-template>
                </div>
              </div>
            </div>
          </div>

        </div>
      </form>

    </div>
  </div>
</div>
